import { useQuery } from "@tanstack/react-query";
import { queryKeys } from "../../lib/query-keys";
import ApiClient from "../../lib/api-client";

export const useAuth = () => {
  const { data, isLoading: isAuthStatusLoading } = useQuery({
    queryKey: queryKeys.auth.status(),
    queryFn: ApiClient.isAuthenticated,
  });

  const { isAuthenticated, isEmailVerified, email } = data ?? {};

  return { isAuthenticated, isEmailVerified, email, isAuthStatusLoading };
};
